import { render } from "./ChangeBgpPeerForVpc.vue?vue&type=template&id=c5b219d2&scoped=true"
import script from "./ChangeBgpPeerForVpc.vue?vue&type=script&lang=js"
export * from "./ChangeBgpPeerForVpc.vue?vue&type=script&lang=js"

import "./ChangeBgpPeerForVpc.vue?vue&type=style&index=0&id=c5b219d2&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.21.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5b219d2"]])

export default __exports__